export const variableValueTypes = {
  string: 'Строка',
  boolean: 'Логический',
  number: 'Число',
};
